import { render, staticRenderFns } from "./basicMsg.vue?vue&type=template&id=7ec8e9c6&scoped=true&"
import script from "./basicMsg.vue?vue&type=script&lang=js&"
export * from "./basicMsg.vue?vue&type=script&lang=js&"
import style0 from "./basicMsg.vue?vue&type=style&index=0&id=7ec8e9c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec8e9c6",
  null
  
)

export default component.exports